/**
 * 消息类大屏舞台：弹幕 / 上墙 / 霸屏 / 提问墙 / 留言墙共用。
 * 数据来自 snapshot.gameData.messages
 */
<template>
  <div class="msg-stage" :class="'is-' + engineStyle">
    <div class="msg-stage__bg" aria-hidden="true">
      <div class="msg-stage__glow msg-stage__glow--1" />
      <div class="msg-stage__glow msg-stage__glow--2" />
    </div>

    <div class="msg-stage__head">
      <div class="msg-stage__banner">{{ label }}</div>
      <div class="msg-stage__stats">
        <span class="msg-stat">已入场 <em>{{ onlineCount }}</em> 人</span>
        <span class="msg-stat">消息 <em>{{ total }}</em> 条</span>
        <span class="msg-stat">点赞 <em>{{ likes }}</em></span>
      </div>
    </div>

    <div class="msg-wall">
      <div
        v-for="(m, i) in messages"
        :key="m.id || ((m.ts || 0) + '-' + i)"
        class="msg-item"
        :class="'type-' + (m.type || 'message')"
      >
        <img v-if="m.avatar" class="msg-avatar" :src="m.avatar" alt="">
        <span v-else class="msg-avatar is-text">{{ (m.nick || '观').slice(0, 1) }}</span>
        <div class="msg-body">
          <div class="msg-meta">
            <span class="msg-nick">{{ m.nick || '观众' }}</span>
            <span v-if="m.type === 'super_barrage' || m.type === 'show_hog'" class="msg-badge">霸屏</span>
          </div>
          <div class="msg-text">{{ m.text || '点赞支持' }}</div>
        </div>
      </div>
      <div v-if="!messages.length" class="msg-empty">
        <div class="msg-empty__title">等待观众发送消息…</div>
        <div class="msg-empty__tip">手机端打开互动页，即可发送弹幕 / 上墙内容</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageWallScreen',
  props: {
    gameData: { type: Object, default: () => ({}) },
    onlineCount: { type: Number, default: 0 },
    title: { type: String, default: '' }
  },
  computed: {
    messages() {
      const list = (this.gameData && this.gameData.messages) || []
      return list.slice(-12)
    },
    total() {
      const gd = this.gameData || {}
      if (gd.messageCount != null) return Number(gd.messageCount) || 0
      return ((gd.messages) || []).length
    },
    likes() {
      return Number((this.gameData && this.gameData.likes) || 0)
    },
    label() {
      return this.title || (this.gameData && this.gameData.label) || '互动消息'
    },
    engineStyle() {
      const label = String(this.title || '')
      if (label.indexOf('霸屏') >= 0) return 'hog'
      if (label.indexOf('提问') >= 0) return 'quiz'
      return 'normal'
    }
  }
}
</script>

<style scoped>
.msg-stage {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: #f5f7fa;
}
.msg-stage__bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 40%, #14284d 0%, #0a1226 62%, #05070f 100%);
  overflow: hidden;
}
.msg-stage__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
}
.msg-stage__glow--1 {
  width: 38vw;
  height: 38vw;
  left: 4%;
  top: 8%;
  background: rgba(64, 158, 255, 0.42);
  animation: msgFloat 9s ease-in-out infinite alternate;
}
.msg-stage__glow--2 {
  width: 32vw;
  height: 32vw;
  right: 4%;
  bottom: 6%;
  background: rgba(140, 90, 255, 0.38);
  animation: msgFloat 11s ease-in-out infinite alternate-reverse;
}
.msg-stage__head {
  position: relative;
  z-index: 3;
  padding-top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}
.msg-stage__banner {
  display: inline-block;
  padding: 8px 36px;
  border-radius: 24px;
  background: linear-gradient(90deg, #7b3cff, #c84bff);
  font-size: 28px;
  letter-spacing: 4px;
  box-shadow: 0 0 24px rgba(160, 80, 255, 0.55);
}
.msg-stage__stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}
.msg-stat {
  padding: 5px 16px;
  border-radius: 999px;
  font-size: 16px;
  color: #dbeafe;
  background: rgba(10, 18, 40, 0.55);
  border: 1px solid rgba(120, 170, 255, 0.25);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.85);
}
.msg-stat em {
  font-style: normal;
  font-weight: 800;
  color: #79bbff;
  font-variant-numeric: tabular-nums;
}
.msg-wall {
  position: absolute;
  left: 50%;
  top: 150px;
  bottom: 24px;
  transform: translateX(-50%);
  width: min(1200px, 88vw);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 10px;
  overflow: hidden;
  z-index: 2;
}
.msg-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: left;
  animation: msgIn 0.4s ease both;
}
.msg-item.type-super_barrage,
.msg-item.type-show_hog {
  background: linear-gradient(90deg, rgba(255, 200, 90, 0.22), rgba(255, 140, 60, 0.12));
  border-color: rgba(255, 210, 120, 0.55);
  box-shadow: 0 0 24px rgba(255, 190, 80, 0.18);
}
.msg-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.25);
}
.msg-avatar.is-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #cfe3ff;
  background: linear-gradient(135deg, #2f4f86, #182844);
}
.msg-body {
  flex: 1;
  min-width: 0;
}
.msg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}
.msg-nick {
  color: #79bbff;
  font-size: 18px;
  font-weight: 600;
}
.msg-badge {
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 13px;
  color: #ffe6a0;
  background: rgba(255, 160, 60, 0.18);
  border: 1px solid rgba(255, 210, 120, 0.5);
}
.msg-text {
  font-size: 24px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.75);
}
.msg-item.type-super_barrage .msg-text,
.msg-item.type-show_hog .msg-text {
  font-size: 30px;
  font-weight: 700;
  color: #ffe6a0;
}
.msg-empty {
  margin: auto;
  text-align: center;
}
.msg-empty__title {
  font-size: 28px;
  font-weight: 600;
  color: #cbd5e1;
  margin-bottom: 10px;
}
.msg-empty__tip {
  font-size: 18px;
  color: #8fa3bf;
}
@keyframes msgIn {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes msgFloat {
  from { transform: translate(0, 0) scale(1); }
  to { transform: translate(3%, 4%) scale(1.12); }
}
</style>
